@switch (state()) {
  @case (PageState.LOADING) {
    <nz-row [nzAlign]="'middle'" [nzJustify]="'center'" class="flex-auto">
      <nz-col>
        <nz-spin [nzSimple]="true" [nzSize]="'large'" />
      </nz-col>
    </nz-row>
  }
  @case (PageState.CAPTCHA_ERROR) {
    <nz-row [nzAlign]="'middle'" [nzJustify]="'center'" class="flex-auto">
      <nz-col [nzSpan]="24">
        <nz-result
          i18n-nzTitle="@@page-profile-content-captcha-error-result-title"
          nzTitle="Forbidden"
          i18n-nzSubTitle="@@page-profile-content-captcha-error-result-subtitle"
          nzSubTitle="Wow, looks like you're a robot. If not, reload the page"
          [nzStatus]="'403'" />
      </nz-col>
    </nz-row>
  }
  @case (PageState.NOT_FOUND_ERROR) {
    <nz-row [nzAlign]="'middle'" [nzJustify]="'center'" class="flex-auto">
      <nz-col [nzSpan]="24">
        <nz-result
          i18n-nzTitle="@@page-profile-content-not-found-error-result-title"
          nzTitle="Not found"
          i18n-nzSubTitle="
            @@page-profile-content-not-found-error-result-subtitle"
          nzSubTitle="The requested user wasn't found"
          [nzStatus]="'404'">
          <div nz-result-extra>
            <button
              i18n="@@go-back-to-search"
              [nzType]="'primary'"
              [routerLink]="'/'"
              nz-button>
              Go back to search
            </button>
          </div>
        </nz-result>
      </nz-col>
    </nz-row>
  }
  @case (PageState.VALIDATION_ERROR) {
    <nz-row [nzAlign]="'middle'" [nzJustify]="'center'" class="flex-auto">
      <nz-col [nzSpan]="24">
        <nz-result
          i18n-nzTitle="@@page-profile-content-validation-error-result-title"
          nzTitle="Invalid username"
          i18n-nzSubTitle="
            @@page-profile-content-validation-error-result-subtitle"
          nzSubTitle="Please, enter valid username"
          [nzIcon]="'instagram'"
          [nzStatus]="'warning'">
          <div nz-result-extra>
            <button
              i18n="@@go-back-to-search"
              [nzType]="'primary'"
              [routerLink]="'/'"
              nz-button>
              Go back to search
            </button>
          </div>
        </nz-result>
      </nz-col>
    </nz-row>
  }
  @case (PageState.UNEXPECTED_ERROR) {
    <nz-row [nzAlign]="'middle'" [nzJustify]="'center'" class="flex-auto">
      <nz-col [nzSpan]="24">
        <nz-result
          i18n-nzTitle="@@page-profile-content-unexpected-error-result-title"
          nzTitle="Something's broken"
          i18n-nzSubTitle="
            @@page-profile-content-unexpected-error-result-subtitle"
          nzSubTitle="Please, reload the page or come back later"
          [nzStatus]="'500'" />
      </nz-col>
    </nz-row>
  }
  @case (PageState.OK) {
    @let _userDTO = userDTO()!;
    <nz-row>
      <nz-col
        [nzLg]="{ span: 18, offset: 3 }"
        [nzMd]="{ span: 20, offset: 2 }"
        [nzSm]="{ span: 22, offset: 1 }"
        [nzXs]="{ span: 22, offset: 1 }">
        <app-info [userDTO]="_userDTO" />
      </nz-col>
    </nz-row>
    <nz-row>
      <nz-col
        [nzLg]="{ span: 18, offset: 3 }"
        [nzMd]="{ span: 20, offset: 2 }"
        [nzSm]="{ span: 22, offset: 1 }"
        [nzXs]="{ span: 22, offset: 1 }"
        class="ya-banner-250"
        id="yandex_rtb_R-A-15626278-7" />
    </nz-row>
    @if (_userDTO.private) {
      <nz-row [nzAlign]="'middle'" [nzJustify]="'center'" class="flex-auto">
        <nz-col [nzSpan]="24">
          <nz-result
            i18n-nzTitle="@@page-profile-content-private-account-result-title"
            nzTitle="Private account"
            i18n-nzSubTitle="
              @@page-profile-content-private-account-result-subtitle"
            nzSubTitle="Unfortunately, you can't view private accounts"
            [nzIcon]="'lock'"
            [nzStatus]="'info'" />
        </nz-col>
      </nz-row>
    } @else {
      <nz-row>
        <nz-col
          [nzLg]="{ span: 18, offset: 3 }"
          [nzMd]="{ span: 20, offset: 2 }"
          [nzSm]="{ span: 22, offset: 1 }"
          [nzXs]="{ span: 22, offset: 1 }">
          <nz-tabset
            [nzCentered]="true"
            (nzSelectedIndexChange)="onSelectedTabIndexChanged($event)">
            <nz-tab [nzTitle]="storiesTabTitle">
              <ng-template #storiesTabTitle>
                <nz-icon [nzType]="'plus-circle'" [nzTheme]="'outline'" />
                <span i18n="@@page-profile-content-stories-tab-title"
                  >Stories</span
                >
              </ng-template>
              <ng-template nz-tab>
                <app-stories [userDTO]="_userDTO" />
              </ng-template>
            </nz-tab>
            <nz-tab [nzTitle]="highlightsTabTitle">
              <ng-template #highlightsTabTitle>
                <nz-icon [nzType]="'box-plot'" [nzTheme]="'outline'" />
                <span i18n="@@page-profile-content-highlights-tab-title"
                  >Highlights</span
                >
              </ng-template>
              <ng-template nz-tab>
                <app-highlights [userDTO]="_userDTO" />
              </ng-template>
            </nz-tab>
            <nz-tab [nzTitle]="postsTabTitle">
              <ng-template #postsTabTitle>
                <nz-icon [nzType]="'table'" [nzTheme]="'outline'" />
                <span i18n="@@page-profile-content-posts-tab-title">Posts</span>
              </ng-template>
              <ng-template nz-tab>
                <app-posts [userDTO]="_userDTO" />
              </ng-template>
            </nz-tab>
            <nz-tab [nzTitle]="reelsTabTitle">
              <ng-template #reelsTabTitle>
                <nz-icon [nzType]="'play-circle'" [nzTheme]="'outline'" />
                <span i18n="@@page-profile-content-reels-tab-title">Reels</span>
              </ng-template>
              <ng-template nz-tab>
                <app-reels [userDTO]="_userDTO" />
              </ng-template>
            </nz-tab>
          </nz-tabset>
        </nz-col>
      </nz-row>
    }
    <nz-row>
      <nz-col
        [nzLg]="{ span: 18, offset: 3 }"
        [nzMd]="{ span: 20, offset: 2 }"
        [nzSm]="{ span: 22, offset: 1 }"
        [nzXs]="{ span: 22, offset: 1 }"
        id="yandex_rtb_R-A-15626278-8" />
    </nz-row>
  }
}
